import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Container, Segment, Table, Dimmer, Loader } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { getBillingHistoryAction } from 'state/business/actions';
import { SemanticToastContainer } from 'react-semantic-toasts';

const mapStateToPropsBillingHistory = ({ business }) => ({
  billingHistory: business.billingHistory,
  loadingOutlets: business.loadingOutlets,
  allBusiness: business.allBusiness,
});

const BillingHistory = connect(mapStateToPropsBillingHistory)(props => {
  const { dispatch, billingHistory, allBusiness, loadingOutlets } = props;
  const businessId = allBusiness.data[allBusiness.activeIndex].id;
  const billingCycle = allBusiness.data[allBusiness.activeIndex].billing_cycle;

  useEffect(() => {
    dispatch(getBillingHistoryAction({ businessId }));
  }, [businessId, dispatch]);

  return (
    <Container
      style={{ overflowY: 'scroll', maxHeight: '50vh', padding: '1vh' }}
    >
      <SemanticToastContainer />
      <p>Billing Cycle : {billingCycle}</p>
      <Segment style={{ padding: '0px' }}>
        <Dimmer active={loadingOutlets}>
          <Loader size="massive">Loading</Loader>
        </Dimmer>
        <Table celled selectable style={{ margin: '0px' }}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Invoice Date</Table.HeaderCell>
              <Table.HeaderCell>Invoice Number</Table.HeaderCell>
              <Table.HeaderCell>Period</Table.HeaderCell>
              <Table.HeaderCell>Amount</Table.HeaderCell>
              <Table.HeaderCell>Status</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {billingHistory.data && billingHistory.data.billings.length > 0 ? (
              billingHistory.data.billings.map(history => {
                let keys = '';
                Object.keys(history).forEach(key => {
                  keys += history[key];
                });
                const convertDate = payloadDate => {
                  if (payloadDate === null) return '-';
                  const newPayloadDate = payloadDate.substr(
                    0,
                    payloadDate.indexOf('Z') + 1
                  );
                  const dateTimeFormat = new Intl.DateTimeFormat('id', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                  });
                  const date = new Date(newPayloadDate);
                  return dateTimeFormat.format(date);
                };
                const formatCurrency = payloadCurrency => {
                  if (payloadCurrency === null) return '-';
                  const formatter = new Intl.NumberFormat('id', {
                    style: 'currency',
                    currency: 'IDR',
                  });

                  return formatter.format(payloadCurrency);
                };
                return (
                  <Table.Row key={`${keys}`}>
                    <Table.Cell key={`${keys}invoice-date`}>
                      {convertDate(history.invoice_date)}
                    </Table.Cell>
                    <Table.Cell
                      style={{ color: 'blue' }}
                      key={`${keys}invoice-number`}
                    >
                      <a
                        href={history.url}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {history.invoice_number}
                      </a>
                    </Table.Cell>
                    <Table.Cell key={`${keys}period`}>
                      {convertDate(history.start_period)} -{' '}
                      {convertDate(history.end_period)}
                    </Table.Cell>
                    <Table.Cell key={`${keys}amount`}>
                      {formatCurrency(history.amount)}
                    </Table.Cell>
                    {history.status === 'paid' ? (
                      <Table.Cell
                        style={{ color: 'green' }}
                        key={`${keys}status`}
                      >
                        {history.status.toUpperCase()}
                      </Table.Cell>
                    ) : (
                      <Table.Cell
                        style={{ color: 'red' }}
                        key={`${keys}status`}
                      >
                        {history.status.toUpperCase()}
                      </Table.Cell>
                    )}
                  </Table.Row>
                );
              })
            ) : (
              <>
                <Table.Row>
                  <Table.Cell colSpan={5} textAlign="center">
                    No Billing History
                  </Table.Cell>
                </Table.Row>
              </>
            )}
          </Table.Body>
        </Table>
      </Segment>
    </Container>
  );
});

BillingHistory.propTypes = {
  dispatch: PropTypes.func.isRequired,
  billingHistory: PropTypes.object.isRequired,
  loadingOutlets: PropTypes.bool.isRequired,
  allBusiness: PropTypes.object.isRequired,
};

export default BillingHistory;
